import React from 'react';
import styles from '../ScoreRules/ScoreRules.module.css';

const EloDescription = () => {
    return (
        <div className={styles.scoreRulesContainer}>
            <div className={styles.scoreRulesText}>
                <h5>Czym jest Elo?</h5>
                <p>
                    System rankingowy Elo to metoda szacowania względnej siły gracza (lub drużyny).
                    Pokonanie przeciwnika z wyższym rankingiem daje więcej punktów niż pokonanie
                    słabszego rywala. Przeciwnik traci tyle samo punktów, ile zwycięzca zyskuje.
                </p>

                <h5>Geneza</h5>
                <p>
                    Nazwa pochodzi od Arpada Elo — węgiersko-amerykańskiego szachisty i profesora fizyki.
                    Najsłynniej z Elo korzysta FIDE (szachy), ale metoda jest stosowana także w innych grach i sportach.
                </p>

                <h5>Elo w Bocheńskim Towarzystwie Tenisowym</h5>
                <p>
                    Każdy nowy użytkownik zaczyna od 1000 punktów Elo — osobno w singlu i deblu.
                    Ranking aktualizujemy przy każdym wprowadzonym wyniku meczu. Na liście widoczni są
                    wyłącznie gracze, którzy zagrali przynajmniej jeden mecz w ciągu ostatnich 365 dni.
                </p>

                <h5>Elo w grze deblowej</h5>
                <p>
                    Elo w deblu przypisujemy indywidualnie każdemu zawodnikowi. Do obliczeń meczu
                    wykorzystujemy średnią arytmetyczną Elo obu partnerów w parze.
                </p>

                <h5>Ostatnia zmiana ELO</h5>
                <p>
                    Na każdej karcie gracza w prawym górnym rogu widoczna jest zmiana ELO dla ostatnio rozegranego meczu.
                </p>

                <h5>Wskaźniki formy – jak czytać paski</h5>
                <p>
                    Na karcie gracza widzisz dwa paski postępu:
                </p>
                <ul>
                    <li>
                        <strong>Wygranych</strong> — procent zwycięstw w całej dostępnej historii (<em>od kiedy liczymy Elo</em>).
                        W nawiasie pokazujemy łączną liczbę rozegranych meczów.
                    </li>
                    <li>
                        <strong>Ostatnie 60 dni</strong> — procent zwycięstw liczony wyłącznie z meczów rozegranych w ostatnich 60 dniach.
                        Jeśli gracz nie zagrał w tym okresie, zobaczysz komunikat <em>„brak danych”</em>.
                    </li>
                </ul>

                <h5>Kolory pasków</h5>
                <ul>
                    <li><strong>Zielony</strong> — wynik ≥ 67%</li>
                    <li><strong>Żółty</strong> — wynik od 34% do 66.9%</li>
                    <li><strong>Czerwony</strong> — wynik &lt; 34%</li>
                </ul>

                <h5>„Mała próba”</h5>
                <p>
                    Przy pasku <strong>Ostatnie 60 dni</strong> może pojawić się etykieta <em>„mała próba”</em>.
                    Oznacza to, że w ostatnich 60 dniach gracz rozegrał niewiele meczów (mniej niż 5),
                    więc procent może być niestabilny. W takiej sytuacji pasek jest lekko „usztywniony”
                    względem całkowitej skuteczności, aby uniknąć skrajnych skoków przy 1–2 meczach.
                </p>

                <h5>Uwagi</h5>
                <ul>
                    <li>Wartości procentowe to: <code>zwycięstwa / mecze × 100%</code>.</li>
                    <li>W deblu statystyki dotyczą konkretnego gracza, niezależnie od partnerów.</li>
                </ul>
            </div>
        </div>
    );
};

export default EloDescription;
